module.exports = __webpack_public_path__ + "static/e696a9ad-afb7-4f37-858e-df5693da94df-7470d7938619c1485d696f58f6c38ea9.webp";